import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'


function RTISection4AdministrationEle6Pg() {
    return(
        <>
            
                <div className='container'>
                            <div className='ms-3'>
                                <h4>Organisation and Functions</h4>
                                <table className="table table-striped">

                                <tbody>
<tr>
<td >
<strong>S. No.</strong>
</td>
<td >
<strong>Item</strong>
</td>
<td >
<strong>Details</strong>
</td>
</tr>
<tr>
<td>
<strong>1.1</strong>
</td>
<td colspan="2">
<strong>Particulars of its organisation, functions and duties [Section 4(1)(b)(i)]</strong>
</td>
</tr>
<tr>
<td>
1.1.1
</td>
<td>
Name and address of the Organization
</td>
<td>
  <b>Indian Institute of Technology Tirupati</b><br /><br />
  <b>Address:</b><br /><br />
 Indian Institute of Technology Tirupati<br />
Yerpedu – Venkatagiri Road, Yerpedu Post,<br />
Tirupati District, Andhra Pradesh - 517619.<br /><br />

</td>
</tr>
<tr>
<td>
1.1.2
</td>
<td>
Head of the Organization
</td>
<td>
<b>Director, IIT Tirupati</b>
</td>
</tr>
<tr>
<td>
1.1.3
</td>
<td>
Vision, Mission and Key Objectives&nbsp;
</td>
<td>
<a className="c-link" href="https://iittp.ac.in/vision" target="_blank;">Click Here</a>
</td>
</tr>
<tr>
<td>
1.1.4
</td>
<td>
Functions and duties
</td>
<td>
As per Acts and Statutes
<ul className="rti4">
<li className="rti5"><a className="c-link" href="https://files.iittp.ac.in/pdfs/rti/The%20Institutes%20of%20Technology%20Act%201961.pdf">The Institutes of Technology Act, 1961</a></li>
<li className="rti5"><a className="c-link" href="https://files.iittp.ac.in/pdfs/rti/The%20Institutes%20of%20Technology%20(Amendment)%20Act%202016%20IIT%20Tirupati.pdf">The Institutes of Technology (Amendment) Act, 2016</a></li>
  <li className="rti5"><a className="c-link" href="https://files.iittp.ac.in/pdfs/rti/Statutes-636-716%20-%20IIT%20TIRUPATI-2.pdf"><span>Statutes</span></a>&nbsp;of IIT Tirupati</li>
</ul>
 
</td>
</tr>
<tr>
<td>
1.1.5
</td>
<td>
Organization Chart
</td>
<td>
<a className="c-link" href="https://iittp.ac.in/leadership/organizational-structure">https://iittp.ac.in/leadership/organizational-structure</a>
</td>
</tr>
<tr>
<td>
1.1.6
</td>
<td>
Any other details – the genesis, inception, formation of the department and the HoDs from time to time as well as the committees / Commissions constituted from time to time have been dealt
</td>
<td>
<a className="c-link" href="https://iittp.ac.in/aboutus">https://iittp.ac.in/aboutus</a><br />
<a className="c-link" href="https://iittp.ac.in/leadership/board-of-governors">https://iittp.ac.in/leadership/board-of-governors</a><br />
<a className="c-link" href="https://iittp.ac.in/leadership/acad-admin">https://iittp.ac.in/leadership/acad-admin</a><br />
<a className="c-link" href="https://iittp.ac.in/leadership/senate">https://iittp.ac.in/leadership/senate</a><br />
<a className="c-link" href="https://iittp.ac.in/leadership/finance-committee">https://iittp.ac.in/leadership/finance-committee</a><br />
<a className="c-link" href="https://iittp.ac.in/leadership/building-and-work-commitee">https://iittp.ac.in/leadership/building-and-work-commitee</a>
</td>
</tr>
<tr>
<td>
<strong>1.2</strong>
</td>
<td colspan="2">
<strong>Powers and duties of its officers and employees [Section 4(1)(b)(ii)]</strong>
</td>
</tr>
<tr>
<td>
1.2.1
</td>
<td>
Powers and duties of officers (administrative, financial and judicial)&nbsp;
</td>
<td>
The Powers and Duties of the Officers and Employees are derived from the Acts and Statutes and exercised as per the details provided under these Acts and Statutes.
<ul className="rti4">
<li className="rti5"><a className="c-link" href="https://files.iittp.ac.in/pdfs/rti/The%20Institutes%20of%20Technology%20Act%201961.pdf">The Institutes of Technology Act, 1961</a></li>
<li className="rti5"><a className="c-link" href="https://files.iittp.ac.in/pdfs/rti/The%20Institutes%20of%20Technology%20(Amendment)%20Act%202016%20IIT%20Tirupati.pdf">The Institutes of Technology (Amendment) Act, 2016</a></li>
  <li className="rti5"><a className="c-link" href="https://files.iittp.ac.in/pdfs/rti/Statutes-636-716%20-%20IIT%20TIRUPATI-2.pdf"><span>Statutes</span></a> of IIT Tirupati</li>
</ul>
 
</td>
</tr>
<tr>
<td>
1.2.2
</td>
<td>
Power and duties of other employees
</td>
<td>
As per Acts and Statutes
<ul className="rti4">
<li className="rti5"><a className="c-link" href="https://files.iittp.ac.in/pdfs/rti/The%20Institutes%20of%20Technology%20Act%201961.pdf">The Institutes of Technology Act, 1961</a></li>
<li className="rti5"><a className="c-link" href="https://files.iittp.ac.in/pdfs/rti/The%20Institutes%20of%20Technology%20(Amendment)%20Act%202016%20IIT%20Tirupati.pdf">The Institutes of Technology (Amendment) Act, 2016</a></li>
  <li className="rti5"><a className="c-link" href="https://files.iittp.ac.in/pdfs/rti/Statutes-636-716%20-%20IIT%20TIRUPATI-2.pdf"><span>Statutes</span></a> of IIT Tirupati</li>
</ul>

</td>
</tr>
<tr>
<td>
1.2.3
</td>
<td>
Rules / orders under which powers and duty are derived and&nbsp;
</td>
<td>
As per Acts and Statutes, Rules
<ul className="rti4">
<li className="rti5">The Institutes of Technology Act, 1961</li>
<li className="rti5">The Institutes of Technology (Amendment) Act, 2016</li>
  <li className="rti5">Statutes of IIT Tirupati</li>
  <li className="rti5">Delegations of Financial Powers (BOG)</li>
  <li className="rti5">Fundamental Rules &amp; Supplementary Rules</li>
  <li className="rti5">The admission of students and research scholars to various undergraduate and postgraduate courses and Ph.D. is based on guidelines framed for admission to these courses.</li>
</ul>

</td>
</tr>
<tr>
<td>
1.2.4
</td>
<td>
Exercised&nbsp;
</td>
<td>
As per Acts, Statutes, Rules, Guidelines/Norms/Orders/Procedures issued from time to time by the Govt. of India
</td>
</tr>
<tr>
<td>
1.2.5
</td>
<td>
Work allocation&nbsp;
</td>
<td>
As per the details in 1.2.1, 1.2.2 and the work Allocation order
</td>
</tr>
<tr>
<td>
<strong>1.3</strong>
</td>
<td colspan="2">
<strong>Procedure followed in decision making process [Section 4(1)(b)(iii)]</strong>

</td>
</tr>
<tr>
<td>
1.3.1
</td>
<td>
Process of decision making Identify key decision making points
</td>
<td>

<ul className="rti4">
  <li className="rti5">Decisions are taken in accordance with the provisions of the Act/Statutes/Ordinances/Rules &amp; Regulations / Policies etc. of the Institute</li>
  <li className="rti5">The Director, Deans, Registrar, and Officers of the institute have been authorized by the Institutes of Technology Act, 1961, the First Statutes of IIT Tirupati, 2017 and through the Delegation of Financial Powers to take key decisions.</li>
  <li className="rti5">The Institute has adopted a decentralized administrative structure, thereby enabling Departments/ Sections to take decisions in conformity with the rules of the Institute and within the delegated powers.</li>
</ul>

</td>
</tr>
<tr>
<td>
1.3.2
</td>
<td>
Final decision making authority
</td>
<td>
The Director/ Board of Governors / IIT Council / Visitor of the Institute takes the decision as mandated in the Institutes of Technology Act, 1961 and the First Statutes of IIT Tirupati, 2017.
</td>
</tr>
<tr>
<td>
1.3.3
</td>
<td>
Related provisions, acts, rules etc.
</td>
<td>
<ul className="rti4">
<li className="rti5"><a className="c-link" href="https://files.iittp.ac.in/pdfs/rti/The%20Institutes%20of%20Technology%20Act%201961.pdf">The Institutes of Technology Act, 1961</a></li>
<li className="rti5"><a className="c-link" href="https://files.iittp.ac.in/pdfs/rti/The%20Institutes%20of%20Technology%20(Amendment)%20Act%202016%20IIT%20Tirupati.pdf">The Institutes of Technology (Amendment) Act, 2016</a></li>
  <li className="rti5"><a className="c-link" href="https://files.iittp.ac.in/pdfs/rti/Statutes-636-716%20-%20IIT%20TIRUPATI-2.pdf"><span>Statutes</span></a> of IIT Tirupati</li>
  <li className="rti5"><a className="c-link" href="https://files.iittp.ac.in/pdfs/rti/Delegation of FInancial powers wef 010419.pdf" target="_blank;"><span>Delegations of Financial Powers</span></a></li>
</ul>

</td>
</tr>
<tr>
<td>
1.3.4
</td>
<td>
Time limit for taking a decisions, if any
</td>
<td>
<ul className="rti4">
<li className="rti5">Depending upon the type of work and authorities involved the time taken for a decision varies. The decisions are taken at deferent levels mainly at BoG/FC/B&amp;WC/Director and in some cases it is at the level of Ministry of Education. The Institute adhere to the rules/regulation, office memorandum, Acts etc. which prescribed time limit for the concerned matters.</li>
<li className="rti5">The general code for discharge of its daily functions is to accomplish work on a day-to-day basis, keeping in view the requirement and urgency of each case.</li>
</ul>
</td>
</tr>
<tr>
<td>
1.3.5
</td>
<td>
The channel of supervision and accountability 
</td>
<td>
<ul className="rti4">
  <li className="rti5">The channel of supervision and accountability also varies according to the concerned Authority. <a className="c-link" href="https://files.iittp.ac.in/pdfs/rti/Supervision Chart.pdf" target="_blank;"><b>Supervision</b></a></li>
<li className="rti5"><a className="c-link" href="https://iittp.ac.in/leadership/organizational-structure" target="_blank;">As per the Organizational Structure and Hierarchy of the institute.</a></li>
</ul>
</td>
</tr>
<tr>
<td>
<strong>1.4</strong>
</td>
<td colspan="2">
<strong>Norms for discharge of functions [Section 4(1)(b)(iv)]</strong>
</td>
</tr>
<tr>
<td>
1.4.1
</td>
<td>
Nature of functions / services offered
</td>
<td>
<ul className="rti4">
  <li className="rti5">To provide high-quality education in science and technology and provide a creative atmosphere for inter-disciplinary research both by the students and the faculty.</li>
  <li className="rti5">To award the Academic Degree</li>
  <li className="rti5">To carry on sponsored research and Consultancy, as per the requirement of the government and industry.</li>
</ul>

</td>
</tr>
<tr>
<td>
1.4.2
</td>
<td>
Norms / standards for functions / service delivery
</td>
<td>
<ul className="rti4">
<li className="rti5">Norms and standards for various academic programs of the Institute are set by the senate, which also monitors progress and achievements of students under various academic programs.</li>
<li className="rti5">Norms and Standards for various activities of the Institute are laid down by the competent authority, such as the BoG. The academic policies of the Institute are decided by the Senate.</li>
<li className="rti5">The Annual Report prepared under the direction of BoG and its annual meetings along with audited accounts, etc. of the Institute.</li>
<li className="rti5">The Annual Report of the Institute along with Audited Accounts is placed on the table of both the Houses of the Parliament.</li>
</ul>
</td>
</tr>
<tr>
<td>
1.4.3
</td>
<td>
Process by which these services can be accessed
</td>
<td>
<ul className="rti4">
<li className="rti5">IIT Tirupati is an institution of higher learning devoted to teaching and research. All the Administrative Offices, Academic Block, Labs, Facilities, Libraries, Hostels, etc. are located on its Campus which facilitates quick communication channels to and from.</li>
<li className="rti5">The Institute has dedicated faculties and staffs who are engaged in various teaching and non-teaching activities of the Institute with consistent effort and hard work. All the Administrative Offices, Labs, Facilities, Libraries, Hostels, etc. are located on its Campus which facilitates quick communication channels to and from.</li>
</ul>

</td>
</tr>
<tr>
<td>
1.4.4
</td>
<td>
Time-limit for achieving the targets
</td>
<td>
  <a className="c-link" href="https://iittp.ac.in/academics/academic-calender" target="_blank;">Click here</a>
</td>
</tr>
<tr>
<td>
1.4.5
</td>
<td>
Process of redress of grievances
</td>
<td>
  
<ul className="rti4">
<li className="rti5"><a className="c-link" href="https://iittp.ac.in/liaison-officers" target="_blank;">SC/ST/OBC Liaison Officers/Cell</a></li>
  <li className="rti5"><a className="c-link" href="https://iittp.ac.in/anti-ragging" target="_blank;">Anti Ragging Committee</a></li>
  <li className="rti5"><a className="c-link" href="https://iittp.ac.in/internalcomplaintcommittee" target="_blank;">Internal Complaints Committee</a></li>
  <li className="rti5">Statutes of IIT Tirupati</li>
  <li className="rti5">CCS (CCA Rule, 1965)</li>
</ul>

</td>
</tr>
<tr>
<td>
<strong>1.5</strong>
</td>
<td colspan="2">
<strong>Rules, regulations, instructions manual and records for discharging functions [Section 4(1)(b)(v)]</strong>
</td>
</tr>
<tr>
<td>
1.5.1
</td>
<td>
Title and nature of the record / manual / instruction.
</td>
<td>
<ul className="rti4">
  <li className="rti5">The Institutes of Technology Act, 1961</li>
  <li className="rti5">The Institutes of Technology (Amendment) Act, 2016</li>
  <li className="rti5">Statutes of IIT Tirupati</li>
  <li className="rti5">Fundamental Rules &amp; Supplementary Rules</li>
  <li className="rti5">General Financial Rules, 2017</li>
  <li className="rti5">Further Government of India Guidelines / Norms / Orders / Procedures issued from time to time</li>
</ul>
</td>
</tr>
<tr>
<td>
1.5.2
</td>
<td>
List of Rules, regulations, instructions manuals and records
</td>
<td>
<ul className="rti4">
<li className="rti5">Fundamental Rules &amp; Supplementary Rules</li>
<li className="rti5">General Financial Rules, 2017</li>
<li className="rti5">Further Government of India Guidelines / Norms / Orders / Procedures issued from time to time</li>
  <li className="rti5">Ordinance of the Institute</li>
  <li className="rti5">Administrative Office Order / Decisions and Guidelines as approved by Institute’s Governing Body i.e., Board of Governors (BOG), Finance Committee, Senate, and Building and Works Committee</li>
  <li className="rti5">Statement of Annual Account</li>
</ul>
</td>
</tr>
<tr>
<td>
1.5.3
</td>
<td>
Acts / Rules manuals etc.
</td>
<td>
<ul className="rti4">
<li className="rti5"><a className="c-link" href="https://files.iittp.ac.in/pdfs/rti/The%20Institutes%20of%20Technology%20Act%201961.pdf">The Institutes of Technology Act, 1961</a></li>
<li className="rti5"><a className="c-link" href="https://files.iittp.ac.in/pdfs/rti/The%20Institutes%20of%20Technology%20(Amendment)%20Act%202016%20IIT%20Tirupati.pdf">The Institutes of Technology (Amendment) Act, 2016</a></li>
  <li className="rti5"><a className="c-link" href="https://files.iittp.ac.in/pdfs/rti/Statutes-636-716%20-%20IIT%20TIRUPATI-2.pdf"><span>Statutes</span></a> of IIT Tirupati</li>
</ul>

As per Government of India rules stated in
<ul className="rti4">
<li className="rti5">Fundamental Rules</li>
<li className="rti5">Supplementary Rules</li>
<li className="rti5">General Financial Rules</li>
<li className="rti5">Further Government of India Guidelines / Norms / Orders / Procedures issued from time to time</li>
</ul>
</td>
</tr>
<tr>
<td>
1.5.4
</td>
<td>
Transfer policy and transfer orders
</td>
<td>

<ul className="rti4">
<li className="rti5">It is not applicable</li>
</ul>

</td>
</tr>
<tr>
<td>
<strong>1.6</strong>
</td>
<td colspan="2">
<strong>Categories of documents held by the authority under its control [Section 4(1)(b)(vi)]&nbsp;</strong>
</td>
</tr>
<tr>
<td>
1.6.1
</td>
<td>
Categories of documents
</td>
<td>
<a className="c-link" href="https://iittp.ac.in/annualreports">Annual Reports</a><br />Administrative Office Order / Decisions and Guidelines as approved by Institute’s Governing Body i.e., Board of Governors (BOG), Finance Committee, Senate, and Building and Works Committee<br />The Institutes of Technology Act 1961, The Institutes of Technology (Amendment) Act, 2016, The First Statutes of IIT Tirupati, 2017, Certificate of GST Registration, DSIR /Customs Duty Exemption Certificate, PAN Card, Importer-Exporter Certificate, Record of Degrees Awarded, Various MoU.
</td>
</tr>
<tr>
<td>
1.6.2
</td>
<td>
Custodian of documents / categories
</td>
<td>
Registrar, IIT Tirupati.
</td>
</tr>
<tr>
<td>
<strong>1.7</strong>
</td>
<td colspan="2">
<strong>Boards, Councils, Committees and other Bodies constituted as part of the Public Authority [Section 4(1)(b)(viii)]</strong>
</td>
</tr>
<tr>
<td>
1.7.1
</td>
<td>
Name of Boards, Council, Committee etc.
</td>
<td>
Following are the Main Statutory Committees / Governing bodies of the Institute
<ul className="rti4">
<li className="rti5">IIT Council</li>  
<li className="rti5">Board of Governors</li>
<li className="rti5">Senate</li>
<li className="rti5">Finance Committee</li>
<li className="rti5">Building and Works Committee</li>
</ul>
</td>
</tr>
<tr>
<td>
1.7.2
</td>
<td>
Composition
</td>
<td>
Following are the Main Statutory Committees / Governing bodies of the Institute
<ul className="rti4">
  <li className="rti5">IIT Council - As Per The Institute of Technology Act 1961. </li>
<li className="rti5"><a className="c-link" href="https://iittp.ac.in/leadership/board-of-governors">Board of Governors</a></li>
  <li className="rti5"><a className="c-link" href="https://iittp.ac.in/leadership/senate">Senate</a></li>
<li className="rti5"><a className="c-link" href="https://iittp.ac.in/leadership/finance-committee">Finance Committee</a></li>
  <li className="rti5"><a className="c-link" href="https://iittp.ac.in/leadership/building-and-work-commitee">Building and Works Committee</a></li>
</ul>

</td>
</tr>
<tr>
<td>
1.7.3
</td>
<td>
Dates from which constituted
</td>
<td>
<ul className="rti4">
  <li className="rti5">Board of Governors: 13th July, 2018</li>
<li className="rti5">Finance Committee: 22nd September, 2020</li>
  <li className="rti5">Building and Works Committee: 6th September, 2021</li>
</ul>

</td>
</tr>
<tr>
<td>
1.7.4
</td>
<td>
Term / Tenure
</td>
<td>
The Boards/Committees are perpetual in nature and are constituted as per the terms of the Institutes of Technology Act, 1961 and the Statutes of the institute. 
</td>
</tr>
<tr>
<td>
1.7.5
</td>
<td>
Powers and functions
</td>
<td>
As defined in the Institutes of Technology Act, 1961, the Institutes of Technology (Amendment) Act, 2016 and the First Statutes of IIT Tirupati, 2017.
</td>
</tr>
<tr>
<td>
1.7.6
</td>
<td>
Whether their meetings are open to the public?
</td>
<td>
No
</td>
</tr>
<tr>
<td>
1.7.7
</td>
<td>
Whether the minutes of the meetings are open to the public?
</td>
<td>
Yes
</td>
</tr>
<tr>
<td>
1.7.8
</td>
<td>
Place where the minutes if open to the public are available?
</td>
<td>
  <a className="c-link" href="https://www.iitsystem.ac.in/bogmeetings" target="_blank;">Click Here</a>
</td>
</tr>
<tr>
<td>
<strong>1.8</strong>
</td>
<td colspan="2">
<strong>Directory of officers and employees [Section 4(1)(b)(ix)]</strong>
</td>
</tr>
<tr>
<td>
1.8.1
</td>
<td>
Name and designation
</td>
<td>
<a className="c-link" href="https://iittp.ac.in/contact-iit">https://iittp.ac.in/contact-iit</a>
</td>
</tr>
<tr>
<td>
1.8.2
</td>
<td>
Telephone , fax and email ID
</td>
<td>
<a className="c-link" href="https://iittp.ac.in/contact-iit">https://iittp.ac.in/contact-iit</a>
</td>
</tr>
<tr>
<td>
<strong>1.9</strong>
</td>
<td colspan="2">
<strong>Monthly Remuneration received by officers &amp; employees including system of compensation [Section 4(1)(b)(x)]</strong>
</td>
</tr>
<tr>
<td>
1.9.1
</td>
<td>
List of employees with Gross monthly remuneration
</td>
<td>
<a className="c-link" href="https://files.iittp.ac.in/pdfs/rti/Employees Gross Salary Apr 2021.pdf" target="_blank">Provided in Monthly Remuneration</a>
</td>
</tr>
<tr>
<td>
1.9.2
</td>
<td>
System of compensation as provided in its regulations
</td>
<td>
Compensation are provided as per the Government rules as well as As per the 7th CPC.
  </td>
</tr>
<tr>
<td>
<strong>1.10</strong>
</td>
<td colspan="2">
<strong>Name, designation and other particulars of public information officers [Section 4(1)(b)(xvi)]</strong>
</td>
</tr>
<tr>
<td>
1.10.1
</td>
<td>
Name and designation of the public information officer (PIO), Assistant
Public Information officer (APIO) &amp; Appellate Authority
</td>
<td>
<a className="c-link" href="https://iittp.ac.in/rti">https://iittp.ac.in/rti</a>
</td>
</tr>
<tr>
<td>
1.10.2
</td>
<td>
Address, telephone numbers and email ID of each designated official.
</td>
<td>
<a className="c-link" href="https://iittp.ac.in/rti">https://iittp.ac.in/rti</a>
</td>
</tr>
<tr>
<td>
<strong>1.11</strong>
</td>
<td colspan="2">
<strong>No. of employees against whom Disciplinary action has been proposed / taken [Section 4(2)]</strong>
</td>
</tr>
<tr>
<td>
1.11.1
</td>
<td>
No. of employees against whom disciplinary action has been&nbsp;
(i) Pending for Minor penalty or major penalty proceedings
</td>
<td>
NIL
</td>
</tr>
<tr>
<td>
1.11.2
</td>
<td>
(ii) Finalised for Minor penalty or major penalty proceedings
</td>
<td>
NIL
</td>
</tr>
<tr>
<td>
<strong>1.12</strong>
</td>
<td colspan="2">
<strong>Programmes to advance understanding of RTI (Section 26)</strong>
</td>
</tr>
<tr>
<td>
1.12.1
</td>
<td>
Educational programmes
</td>
<td>
NIL
</td>
</tr>
<tr>
<td>
1.12.2
</td>
<td>
Efforts to encourage public authority to participate in these programmes
</td>
<td>
Not Applicable
</td>
</tr>
<tr>
<td>
1.12.3
</td>
<td>
Training of CPIO/APIO
</td>
<td>
Time to time provided through the Government Training Institutions
</td>
</tr>
<tr>
<td>
1.12.4
</td>
<td>
Update &amp; publish guidelines on RTI by the Public Authorities concerned
</td>
<td>
<a className="c-link" href="https://rti.gov.in/webactrti.htm" target="_blank;">https://rti.gov.in/webactrti.htm</a><br />
  <a className="c-link" href="https://rti.gov.in/rticorner/guide_2013-issue.pdf" target="_blank;">https://rti.gov.in/rticorner/guide_2013-issue.pdf</a>
</td>
</tr>
<tr>
<td>
<strong>1.13</strong>
</td>
<td colspan="2">
<strong>Transfer policy and transfer orders [F No.1/6/2011-IR dt.15.4.2013]</strong>
</td>
</tr>
<tr>
<td>
1.13.1
</td>
<td>
Transfer Policy And Transfer Orders[F No. 1/6/2011- IR Dt. 15.4.2013]
</td>
<td>
Not Applicable
</td>
</tr>
</tbody>

                                </table>
                            </div>
                    </div> 
            
        </>
    );
}

export default RTISection4AdministrationEle6Pg;